import { Button, Stack, Typography } from '@mui/material';
import { IconSvg } from '@/components/Icon';
import { useLoginDisplay } from '@/api/hooks/auth/useLoginDisplay';
import { showToast } from '@/ui/kit/components/toast';
type Props = {
  startSync: () => void;
};
const InitialSyncSejam = (props: Props) => {
  const {
    data
  } = useLoginDisplay();
  const sejamSync = () => {
    if (data?.type === 'mobile') {
      showToast({
        type: 'warning',
        message: 'در حال حاضر امکان همگام سازی سجام وجود ندارد.\n لطفا با پشتیبانی تماس بگیرید'
      });
      return;
    }
    props.startSync();
  };
  return <Stack alignItems='center' sx={{
    px: {
      xs: 'var(--spacing_m)',
      md: 'var(--spacing_xl)'
    }
  }} data-sentry-element="Stack" data-sentry-component="InitialSyncSejam" data-sentry-source-file="InitialSyncSejam.tsx">
      <Stack alignItems='center' sx={{
      width: '100%',
      fontSize: {
        xs: 56,
        md: 72
      },
      py: {
        xs: 'var(--spacing_m)',
        md: 'var(--spacing_l)'
      }
    }} data-sentry-element="Stack" data-sentry-source-file="InitialSyncSejam.tsx">
        <IconSvg component='Sync' data-sentry-element="IconSvg" data-sentry-source-file="InitialSyncSejam.tsx" />
      </Stack>
      <Typography component='p' sx={{
      typography: {
        xs: 'bodyRegular__Wallfund',
        md: 'bodyLargeRegular__Wallfund'
      },
      py: 'var(--spacing_s)'
    }} data-sentry-element="Typography" data-sentry-source-file="InitialSyncSejam.tsx">
        برای سرمایه‌گذاری در طرح‌های زیما، باید حساب زیما و سجام خود را
        همگام‌سازی کنید.
      </Typography>
      <Stack sx={{
      width: '100%',
      pt: 'var(--spacing_m)',
      pb: {
        xs: 'var(--spacing_m)',
        md: 'var(--spacing_xl)'
      }
    }} data-sentry-element="Stack" data-sentry-source-file="InitialSyncSejam.tsx">
        <Button onClick={sejamSync} fullWidth color='primary' variant='contained' size='large' data-sentry-element="Button" data-sentry-source-file="InitialSyncSejam.tsx">
          همگام‌سازی سجام
        </Button>
      </Stack>
    </Stack>;
};
export default InitialSyncSejam;